import * as ActionTypes from '../constants/actionTypes'
import { roleGetCount, roleGetPage } from '../api/role'

export const fetchItems = (params = {}) => (dispatch) => {
  dispatch({ type: ActionTypes.ROLELIST_FETCHITEMS_LOAD })

  roleGetCount(params).then((res) => {
    const total = parseInt(res.result.n_count)

    roleGetPage(params).then((res) => {
      const items = res.result

      const newItems = items

      items.map((obj, key) =>
        newItems[key].n_disable = obj.n_disable === '1')

      dispatch({
        type: ActionTypes.ROLELIST_FETCHITEMS_SUCCEED,
        items: newItems,
        total,
      })
    }).catch((err) => {
      dispatch({
        type: ActionTypes.ROLELIST_FETCHITEMS_FAIL,
        fetchItemsError: 'Ошибка получения списка ролей',
      })
    })
  }).catch((err) => {
    dispatch({
      type: ActionTypes.ROLELIST_FETCHITEMS_FAIL,
      fetchItemsError: 'Ошибка получения кол-ва ролей',
    })
  })
}

export const changeTable = params => (dispatch) => {
  const { pagination = {}, filters = {}, sorter = {} } = params
  dispatch({
    type: ActionTypes.ROLELIST_CHANGETABLE_CHANGE,
    pagination,
    filters,
    sorter,
  })
}

export const searchTable = ({ isSearching }) => (dispatch) => {
  dispatch({
    type: ActionTypes.ROLELIST_SEARCHTABLE_SEARCH,
    isSearching,
  })
}

export const editSearch = params => (dispatch) => {
  const { search } = params
  dispatch({
    type: ActionTypes.ROLELIST_SEARCHTABLE_EDIT,
    search,
  })
}




// WEBPACK FOOTER //
// src/actions/roleList.js